import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Button } from "@material-ui/core";
import React from "react";
import { withTranslate } from "react-admin";

const BackButton = ({ translate, ...props }) => {
  const handleClick = () => {
    const deviceOrigin = localStorage.getItem("device_origin");
    if (deviceOrigin) {
      window.location.hash = deviceOrigin;
      localStorage.removeItem("device_origin");
    } else {
      window.location.hash = "#/device";
    }
  };

  return (
    <Button onClick={handleClick} {...props}>
      <ArrowBackIcon /> {translate("ra.action.back")}
    </Button>
  );
};

export default withTranslate(BackButton);
